<kpd-confirm-dialog key="confirm"></kpd-confirm-dialog>

<kpd-data-view
  [tableName]="'permissions'"
  [dataProvider]="entityFacade"
  [columnsConfig]="columnsConfig"
  [searchConfig]="searchConfig"
  [urlFunction]="urlFunction"
  (linkClicked)="onLinkClicked($event)"
>
  <ng-template kpdTemplate="toolBar" let-loading="loading">
    <kpd-action-bar>
      <div class="actionbar--hide">
        <span *ngIf="selectedItemIds.length > 0" class="flex-row">
          <kpd-action-consult-overview (action)="onView(selectedItemIds[0])"></kpd-action-consult-overview>
        </span>
        <kpd-action-separator></kpd-action-separator>
      </div>
      <kpd-action
        [icon]="viewType === ViewTypes.Table ? 'view-cards' : 'view-columns'"
        kpdHotkey="mod+m"
        [title]="'Change mode' | translate"
        (action)="onToggleViewType()"
      ></kpd-action>

      <kpd-action
        icon="refresh"
        kpdHotkey="mod+r"
        [title]="'Refresh' | translate"
        [disable]="loading"
        (action)="onRefresh()"
      ></kpd-action>
      <div class="actionbar--hide">
        <kpd-action icon="bars" (action)="onToggleSidepanel()" [title]="'Open sidepanel' | translate"></kpd-action>
      </div>
    </kpd-action-bar>
  </ng-template>

  <ng-template kpdTemplate="cardItem" let-item>
    <div class="card">
      <label class="title" translate>Name</label>
      <label class="value">{{ item.name }}</label>
      <label class="title" translate>Description</label>
      <label class="value">{{ item.description | kpdDefault }}</label>
    </div>
  </ng-template>
</kpd-data-view>
